import { PortaleId } from "@/api";
import { portaleHelpers } from "@/utils/portaleUtils";
import { Chip, Tooltip } from "@mui/material";

export default function PortaleChip({ portale }: { portale: PortaleId }) {
  const config = portaleHelpers[portale];

  return (
    <Tooltip title={config.portaleNome}>
      <Chip
        sx={{ backgroundColor: config.portaleChipColor }}
        label={
          <img
            src={config.portaleChipIcon}
            alt={config.portaleNome}
            width={24}
            style={{ paddingTop: 2, paddingBottom: 2 }}
          />
        }
      />
    </Tooltip>
  );
}
